<template>
  <div class="prjNotice">
    <div class="top">
      <div class="topTitle">
        <p class="title">项目公告</p>
        <el-button v-if="prjNoticeAdd" size="small" type="primary" icon="el-icon-plus" @click="addprjNotice"> 新增 </el-button>
      </div>
      <div class="queryArea">
        <el-form ref="form" :model="selectForm" inline class="formStyle" size="small">
          <el-form-item label="标题/摘要:">
            <el-input v-model="selectForm.keyWord" placeholder="请输入标题、摘要" size="small" @keyup.enter.native="fetchData(1)"> </el-input>
          </el-form-item>
          <el-form-item v-if="prjNoticeState" label="状态:">
            <el-select v-model="selectForm.isPublish" size="small" placeholder="请选择" filterable>
              <el-option v-for="item in levelDic" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="日期:">
            <el-date-picker
              v-model="selectForm.value1"
              style="width: 100%"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" plain @click="resetBtn">重置</el-button>
            <el-button size="small" type="primary" @click="fetchData(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading" element-loading-text="数据获取中" class="noticeArea">
      <div v-if="noticeDataList.length === 0" class="noDataStyle">
        <img :src="noDataImg" />
      </div>
      <notice-list
        v-else
        :notice-data-list="noticeDataList"
        :look-notice="look"
        :edit="edit"
        :fetch-data="fetchData"
        :name="name"
        :page="page"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
      </notice-list>
    </div>
    <!-- 新增/编辑 -->
    <notice-add-edit
      :dialog-title="dialogTitle"
      :announdialog-visible="AnnoundialogVisible"
      :close="closeAddEdit"
      :announ-form="announForm"
      :add-sure="addSure"
      :preview="preview"
      :file-data="fileData"
      :name="name"
      :select-person-list="selectPersonList"
      :upload-filea="uploadFilea"
    >
    </notice-add-edit>
    <!-- 查看 -->
    <notice-look :dialog-look-title="dialogLookTitle" :announdialog-look-visible="AnnoundialogLookVisible" :table-row="tableRow" :close="closeLook" :name="name"></notice-look>
  </div>
</template>

<script>
import prjNoticeService from "@/CommonDP/service/prjNotice-service";
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import noticeList from "@/CommonDP/components/notice/noticeList";
import noticeLook from "@/CommonDP/components/notice/noticeLook";
import noticeAddEdit from "@/CommonDP/components/notice/noticeAddEdit";
import { uploader } from "@/CommonDP/utils/IUploader/dp";
export default {
  name: "PrjNotice",
  components: {
    noticeList,
    noticeLook,
    noticeAddEdit
  },
  data() {
    return {
      selectForm: {
        keyWord: "",
        isPublish: "",
        value1: []
      },
      levelDic: [
        {
          name: "启用",
          id: 1
        },
        {
          name: "禁用",
          id: 2
        },
        {
          name: "草稿",
          id: 0
        }
      ],
      noticeDataList: [],
      page: {
        totalCount: 0,
        pageNum: 1,
        pageSize: 20
      },
      loading: false,
      dialogTitle: "新增",
      AnnoundialogVisible: false,
      announForm: {
        noticeTitle: "",
        content: "",
        isTop: 0,
        isOpen: 1,
        noticeAbstract: "",
        fileIds: [],
        userIds: [],
        userNames: ""
      },
      tableRow: {},
      dialogLookTitle: "查看",
      AnnoundialogLookVisible: false,
      fileData: [],
      selectPersonList: [],
      name: "prj",
      noDataImg: require("@/CommonDP/assets/workProjectBoard/notNotice.png")
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj,
      uploadFilesData: (state) => state.prjNotice.uploadFilesData
    }),
    prjNoticeAdd() {
      return checkPermission(this.$allPerms.PRJNOTICE_ADD);
    },
    prjNoticeState() {
      return checkPermission(this.$allPerms.PRJNOTICE_STATE);
    }
  },
  created() {
    this.queryNoticeList();
  },
  methods: {
    fetchData(val) {
      this.page.pageNum = val;
      this.noticeDataList = [];
      this.queryNoticeList();
    },
    resetBtn() {
      this.selectForm.keyWord = "";
      this.selectForm.isPublish = "";
      this.selectForm.value1 = [];
      this.page.pageNum = 1;
      this.noticeDataList = [];
      this.queryNoticeList();
    },
    async queryNoticeList() {
      this.loading = true;
      const params = {
        endTime: null,
        startTime: null,
        enterpriseId: this.enterpriseId,
        keyWord: this.selectForm.keyWord,
        isPublish: this.selectForm.isPublish,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        prjId: this.prjInfo.prjId
      };
      if (this.selectForm.value1.length) {
        params.endTime = this.selectForm.value1[1] + " " + "23:59:59";
        params.startTime = this.selectForm.value1[0] + " " + "00:00:00";
      }
      try {
        const res = await prjNoticeService.prjNoticeList(params);
        this.noticeDataList = res.data;
        this.page.totalCount = res.totalCount;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    addprjNotice() {
      this.dialogTitle = "新增";
      this.openAddFu();
    },
    async addSure(announForm, fileData, val) {
      this.announForm = announForm;
      this.fileData = fileData;
      this.announForm.fileIds = this.fileData.map((item) => {
        return item.fileId;
      });
      if (this.dialogTitle === "新增") {
        const params = {
          content: this.announForm.content,
          noticeTitle: this.announForm.noticeTitle,
          fileIds: this.announForm.fileIds,
          isPublish: val,
          isTop: this.announForm.isTop,
          isOpen: this.announForm.isOpen,
          prjId: this.prjInfo.prjId,
          noticeAbstract: this.announForm.noticeAbstract,
          prjName: this.prjInfo.prjName,
          userIds: this.announForm.isOpen ? [] : this.announForm.userIds
        };
        await prjNoticeService.prjNoticeAdd(params);
        this.$message.success("添加成功");
      } else {
        const params = {
          noticeId: this.tableRow.noticeId,
          content: this.announForm.content,
          noticeTitle: this.announForm.noticeTitle,
          fileIds: this.announForm.fileIds,
          isPublish: val,
          isTop: this.announForm.isTop,
          isOpen: this.announForm.isOpen,
          prjId: this.prjInfo.prjId,
          noticeAbstract: this.announForm.noticeAbstract,
          prjName: this.prjInfo.prjName,
          userIds: this.announForm.isOpen ? [] : this.announForm.userIds
        };
        await prjNoticeService.prjNoticeUpdate(params);
        this.$message.success("修改成功");
      }
      this.AnnoundialogVisible = false;
      this.fetchData(1);
    },
    async edit(row) {
      this.tableRow = row;
      this.dialogTitle = "编辑";
      await this.openAddFu();
      const res = await prjNoticeService.prjNoticeGet(row.noticeId);
      this.announForm = res.data;
      this.selectPersonList = res.data.userList;
      this.announForm.userNames = res.data.userList.map((ele) => ele.name).join(",");
      this.announForm.userIds = res.data.userList.map((item) => {
        return item.userId;
      });
      this.fileData = res.data.files;
    },
    openAddFu() {
      this.AnnoundialogVisible = true;
      this.fileData = [];
      this.selectPersonList = [];
      this.$nextTick(() => {
        this.announForm.noticeTitle = "";
        this.announForm.content = "";
        this.announForm.isTop = 0;
        this.announForm.isOpen = 1;
        this.announForm.noticeAbstract = "";
        this.announForm.fileIds = [];
        this.announForm.userIds = [];
        this.announForm.userNames = "";
      });
    },
    async look(row) {
      const res = await prjNoticeService.prjNoticeGet(row.noticeId);
      this.tableRow = res.data;
      this.tableRow.userNames = res.data.userList.map((ele) => ele.name).join(",");
      if (row.isPublish === "1") {
        const data = new FormData();
        data.append("noticeId", row.noticeId);
        await prjNoticeService.noticeReadRecordAdd(data);
      }
      this.dialogLookTitle = "查看";
      this.AnnoundialogLookVisible = true;
    },
    preview(data) {
      this.announForm = data;
      this.dialogLookTitle = "预览";
      this.AnnoundialogLookVisible = true;
      this.tableRow = this.announForm;
    },
    async uploadFilea() {
      const params = {
        prjId: this.prjInfo.prjId,
        folderId: "",
        versionId: ""
      };
      await uploader.getHiddenParams(params);
      const list = await uploader.open({ params, showPanel: true, once: false });
      list.forEach(this.fileAdded);
    },
    closeLook() {
      this.AnnoundialogLookVisible = false;
    },
    closeAddEdit() {
      this.AnnoundialogVisible = false;
    },
    fileAdded(val) {
      if (val && val.fileId) {
        this.fileData.push(val);
      } else {
        this.fileData = [];
      }
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.queryNoticeList();
    },
    // 分页
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.queryNoticeList();
    }
  }
};
</script>

<style lang="scss" scoped>
.prjNotice {
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    background: #fff;
    .topTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e5e8f1;
      padding: var(--middle-space) var(--big-space);
      .title {
        color: var(--key-color);
        font-size: 16px;
        font-weight: 700;
      }
    }
    .queryArea {
      padding: var(--middle-space) var(--big-space) 0;
      .formStyle {
        .el-form-item {
          margin-bottom: 0px;
        }
      }
    }
  }

  .noticeArea {
    width: 100%;
    height: 1px;
    flex-grow: 1;
  }
  .noDataStyle {
    width: 100%;
    height: calc(100vh - 212px);
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
